/**
 * @generated SignedSource<<5ccb7e91993e0ec84ef5b2c73854a5b7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileTabs_tradeFirm$data = {
  readonly publicProfile: {
    readonly designProjectsCount: number | null;
    readonly portfolios: ReadonlyArray<{
      readonly itemCount: number | null;
    } | null> | null;
    readonly urlLabel: string | null;
  } | null;
  readonly " $fragmentType": "ProfileTabs_tradeFirm";
};
export type ProfileTabs_tradeFirm$key = {
  readonly " $data"?: ProfileTabs_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileTabs_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileTabs_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "designProjectsCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioV1",
          "kind": "LinkedField",
          "name": "portfolios",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "e22a1a2809e4d185dc9aaff2d6e2d68b";

export default node;
